import { title } from "process";
import { getGlobal } from "../../../global";
import { selectChat, selectUser, selectUserFullInfo } from "../../../global/selectors";
import useInfiniteScroll from "../../../hooks/useInfiniteScroll";
import React, { useState, FC, memo, useEffect, useRef, useMemo } from "../../../lib/teact/teact";
import buildClassName from "../../../util/buildClassName";
import MessageInput from "../../middle/composer/MessageInput";
import Button from "../../ui/Button";
import Checkbox from "../../ui/Checkbox";
import InfiniteScroll from "../../ui/InfiniteScroll";
import InputText from "../../ui/InputText";
import ListItem from "../../ui/ListItem";
import Modal from "../../ui/Modal";
import SearchInput from "../../ui/SearchInput";
import { LotMessage } from "../types/types";
import '../ui/formCommon.scss'
import { getCurDate, getDateString } from "../utils/DateTimeUtils";
type OwnProps = {
    messages: LotMessage[]
    messageIndex: number;
    title: string; // điều kiện lọc theo tên nhóm
    content: string; // điều kiện lọc theo nộidung
    isOpen: boolean;
    onClose: () => void;
    onIndexChange: (newIndex: number) => void;
    onSearchChange: (query: any) => void;
    onMessagesSelect: (messageSelected: string[]) => void;
    filter?: string;
    onFilterChange:(filterCond:any)=>void;

}

const FilterMessage: FC<OwnProps> = ({
    messages,
    messageIndex,
    isOpen,
    onClose,
    onIndexChange,
    onSearchChange,
    onMessagesSelect,
    filter,
    title,
    content,
    onFilterChange,
}) => {
    const refSearch = useRef()
    const [state, setState] = useState({
        isOpen: isOpen,
        selectedMessgas: [""],
        workDate: getDateString(getCurDate()),
        title: title,
        content: content,
    })
    function handleFilter() {
        onSearchChange({ title: state.title, content: state.content, date: state.workDate })
    }
    setState(prev => ({ ...prev, title: title, content: content }))
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            className={'confirm'}

        >
            <div className="">
                <div className=" form-main">
                    <div className=" form-header">
                        <div className=" form-header lèt-panel">
                            <Button round size="smaller"
                                onClick={() => {
                                    onClose()
                                }}
                                color="translucent"
                            >
                                <i
                                    className='icon icon-arrow-left'
                                    aria-hidden
                                />
                            </Button>
                            <div>Lọc tin nhắn telegram</div>
                        </div>
                    </div>
                    <InputText label="Tên khách/Nhóm telegram"
                        value={title}
                        onChange={(e) => {
                            // setState(prev => ({ ...prev, title: e.target.value }))
                            onFilterChange({title:e.target.value,content:state.content})
                        }}
                    ></InputText>
                    <InputText label="Nội dung tin nhắn"
                        value={content}
                        onChange={(e) => {
                            //setState(prev => ({ ...prev, content: e.target.value }))
                            onFilterChange({content:e.target.value,title:state.title})
                        }}></InputText>
                    {/* <div className=" common-container-row">
                        <div>Ngày</div>
                        <input id="basic-report-date" type="date" className="date-input" value={state.workDate}
                            pattern="\d{2}/\d{2}/\d{4}" placeholder="dd/mm/yyyy"

                            onChange={(e) => {
                                setState((prev: any) => ({ ...prev, workDate: e.target.value }))
                            }
                            }
                        />
                    </div> */}
                    <div className="center-horizontal">
                        <Button size='tiny'
                            onClick={handleFilter}
                        >Lọc</Button>
                    </div>
                </div>
            </div>

        </Modal>
    )
}
export default memo(FilterMessage)